<template>
  <!-- width="600px" 或者  width="60%"   -->
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="工单详情"
      :show-close="true"
      :visible="true"
      :before-close="handleBeforeClose"
      width="1400px"
    >
      <div class="orderDetailMain">
        <div class="orderDetailLeft">
          <CheckOrderLeft :detail="detail"/>
        </div>
        <div class="orderDetailRight">
          <CheckOrderRight :detail="detail" @submitForm="getOrderDetailInfo"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
        <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { getOrderDetailInfo } from '@/api/RecoveryWorkOrder'
import CheckOrderLeft from './CheckOrderLeft'
import CheckOrderRight from './CheckOrderRight'


export default {
  data() {
    return {
      detail: {
        lift: {},
        logList: [],
        liveImageDataList: [],
        orderImageDataList: [],
        signatureImageDataList: [],
        manageItemDTOS: []
      },
    };
  },
  components: {
    CheckOrderLeft,
    CheckOrderRight
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.getOrderDetailInfo()
  },
  methods: {
    async getOrderDetailInfo() {
      const res = await getOrderDetailInfo({orderId: this.editData.orderId})
      if (res.code === 200) {
        this.detail = res.data
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss">
.orderDetailMain {
  display: flex;
  .orderDetailRight, .orderDetailLeft {
    flex: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/RecoveryWorkOrder/components/CheckOrder.vue